import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {faTrash} from '@fortawesome/free-solid-svg-icons';

import {ToolService} from '../tool.service';

const correctFileTypes = ['image/jpeg', 'image/png'];

@Component({
  selector: 'app-tool-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss']
})
export class EditorComponent {
  faTrash = faTrash;
  colorPicker = {
    bgColor: '#000000',
    textColor: '#ffffff'
  };
  editorForm: FormGroup = this.fb.group({
    message: ['', [
      Validators.required,
      Validators.maxLength(160)
    ]],
    bgColor: ['#000000', [
      Validators.required,
      Validators.pattern(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)
    ]],
    textColor: ['#ffffff', [
      Validators.required,
      Validators.pattern(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)
    ]],
    logoHold: [false]
  });
  image = {
    preview: '',
    errors: {
      correct: true
    }
  };

  constructor(
    private fb: FormBuilder,
    public toolService: ToolService,
    public router: Router
  ) {}

  pickerChanged(type: string, color: string) {
    this.editorForm.controls[type].setValue(color);
  }

  colorInputChange(type: string) {
    this.colorPicker[type] = this.editorForm.controls[type].value;
  }

  logoHandler(event: Event) {
    try {
      const target: any = event.target;
      const file: File = target.files[0];
      if ( file ) {

        if ( !this.checkFile(file) ) return;

        const reader = new FileReader();

        reader.onload = (e: any) => {
          return this.image.preview = e.target.result;
        };

        reader.readAsDataURL(file);
      } else {
        console.error('File is not defined');
        return false;
      }
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  private checkFile(file: File): boolean {
    if ( correctFileTypes.indexOf(file.type) === -1 ) {
      this.image.errors.correct = false;
      return false;
    } else {
      this.image.errors.correct = true;
      return true;
    }
  }

  showPreview() {
    if ( this.checkAdData() ) {
      this.toolService.previewShowen.next(true);
      this.router.navigateByUrl('/preview', { skipLocationChange: true });
    }
  }

  checkAdData(): boolean {
    if ( this.editorForm.invalid ) {
      this.editorForm.markAllAsTouched();
      return false;
    }
    if ( !this.image.errors.correct ) return false;

    this.toolService.adInfo = {...this.editorForm.getRawValue(), image: this.image.preview};
    return true;
  }

  removeLogo() {
    this.image = {
      preview: '',
      errors: {
        correct: true
      }
    };
  }
}
